import React from "react";
import { Link } from "@quintype/components";
import { shape, string, array } from "prop-types";
import "./story-tag.m.css";

const Tag = props => (
  <Link href={"/topic/" + props.tag.slug} className="story-tag">
    {props.tag.name}
  </Link>
);

Tag.propTypes = {
  tag: shape({
    slug: string,
    name: string
  })
};

const StoryTags = ({ tags = [] }) => (
  <ul styleName="tag-wrapper">
    {tags.map((tag, index) => (
      <li styleName="tag-element" key={index}>
        <Tag key={index} tag={tag} />
      </li>
    ))}
  </ul>
);

StoryTags.propTypes = {
  tags: array
};

export default StoryTags;
